import React, { Component } from 'react';
import Swal from 'sweetalert2';
import validation from '../../../helper/validation';
import EyeIcons from '../../../assets/icons/eye.svg';
import EyeSlashIcon from "../../../assets/icons/slash-eye-blue.svg";
import CheckBlue from '../../../assets/icons/tick-check-blue.svg';
import {Modal as ModalRs, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

export default class DaftarAkun extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorsMessage: {},
            paketMonth: this.props.paketMonth,
            message: "",
            showPassword: false,
            showConfirmPassword: false,
            modalSetup: false,
            confirmGuide: false,
            confirmActive: false,

        }

        this.validate = this.validate.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }

    sendOTP = () => {
        if (this.props.disableSendOTP) {
            return;
        }
        this.validate('no_whatsapp', this.props.no_whatsapp)

        let form = {
            perusahaan_no_wa: this.props.no_whatsapp,
            half: true
        }
        this.props.request("otp-wa", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.props.setState({ otpwaForm: true })
                    this.props.startTimer()
                }
                if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.failed,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.props.setState({
                    disabledButton: false
                })
            });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (name === 'no_whatsapp') {
            if (value !== '+' && isNaN(value)) {
                return;
            }
        }
        this.props.setState({
            [name]: value
        })
    }

    handleFocus(event) {
        const target = event.target;
        const name = target.name;
        const errorsMessage = this.state.errorsMessage

        if (name === 'password') {
            if (this.state.errorsMessage.hasOwnProperty('confirm_password')) {
                delete errorsMessage.passwordperusahaanconfirm
            }
        }

        if (this.state.errorsMessage.hasOwnProperty(name)) {
            delete errorsMessage[name]
        }

        this.setState({
            errorsMessage,
            disabledButtonErr: Object.keys(this.state.errorsMessage).length > 0 ? true : false
        })
    }

    handleBlur(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.validate(name, value)
    }

    validate(name, value) {
        let errorsMessage = this.state.errorsMessage

        switch (name) {
            case 'no_whatsapp':
                if (value.trim() === '') {
                    errorsMessage[name] = 'No. WhatsApp perusahaan harus diisi!'
                }
                else if (value.length < 9 || value.length > 12) {
                    errorsMessage[name] = 'No. WhatsApp perusahaan tidak valid!'
                } else {
                    delete errorsMessage[name]
                }
                break
            case 'code_otp':
                if (value.trim() === '') {
                    errorsMessage[name] = 'OTP WhatsApp harus diisi!'
                } else {
                    delete errorsMessage[name]
                }
                break
            case 'email':
                const val = validation(value)
                if (val === true) {
                    delete errorsMessage[name]
                } else {
                    errorsMessage[name] = val;
                }
                break
            case 'company_name':
                if (value === "") {
                    errorsMessage[name] = "Nama Perusahaan harus diisi!"
                } else {
                    delete errorsMessage[name]
                }
                break
            case 'password':
                if (value.trim() === '') {
                    errorsMessage[name] = 'Password harus diisi!'
                } else if (value.trim().length < 6) {
                    errorsMessage[name] = 'Password minimal adalah 6 karakter!'
                } else if (this.props.password !== '') {
                    if (value !== this.props.password) {
                        errorsMessage.password = 'Password yang anda masukan berbeda!'
                    } else {
                        delete errorsMessage.password
                    }
                } else {
                    delete errorsMessage[name]
                }
                break
            case 'confirm_password':
                if (this.props.password.trim() !== '' && value.trim() === '') {
                    errorsMessage[name] = 'Ulangi Password harus diisi!'
                } else if (this.props.confirm_password.trim() !== '' && value !== this.props.password) {
                    errorsMessage[name] = 'Password yang anda masukkan berbeda!'
                } else {
                    delete errorsMessage[name]
                }
                break
            default:
                errorsMessage = this.state.errorsMessage
        }

        this.setState({
            errorsMessage,
            disabledButtonErr: Object.keys(this.state.errorsMessage).length > 0 ? true : false
        })
    }

    submitRegister = (mode) => {
        this.validate('email', this.props.email)
        this.validate('password', this.props.password)
        this.validate('confirm_password', this.props.confirm_password)
        this.validate("company_name", this.props.company_name)

        if (Object.keys(this.state.errorsMessage).length > 0) {
            return
        } else {
            this.setState({
                disabledButton: true
            })
        }


        const paket_id = this.props.paket_id && this.props.paket_id !== 0
            ? this.props.paket_id
            : (this.props.paket_selected && this.props.paket_selected.paket_id
                ? this.props.paket_selected.paket_id
                : 0);

        let form = {
            paket_id: paket_id,
            company_name: this.props.company_name,
            email: this.props.email,
            password: this.props.password,
            confirm_password: this.props.confirm_password,
            otp_code: this.props.otp_code,
            no_whatsapp: this.props.no_whatsapp,
            perusahaan_bidang: this.props.bidang_selected,
            paket_month: this.props.paketMonth,
            mode_setup: mode
        }

        this.props.request("register_v3", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.props.setState({ stepHeader: 3, message: response.message })
                }
                if (response && response.failed) {
                    const errorsMessage = this.state.errorsMessage
                    if (response && response.failed === 'Email sudah dipakai') {
                        errorsMessage.emailregister = 'Email sudah dipakai!'
                    } else {
                        Swal.fire({
                            title: 'Gagal!',
                            text: response.failed,
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        })
                    }
                    this.setState({
                        errorsMessage,
                        disabledButtonErr: true
                    })
                }
                if (!response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: 'Tidak dapat terhubung ke server. Silakan coba lagi.',
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    disabledButton: false
                })
            });
    }

    render() {
        return (
            <>
                <ModalRs
                    className="modal-content-export"
                    isOpen={this.state.confirmActive}
                    toggle={() => this.setState({confirmActive: false})}
                >
                    <ModalHeader toggle={() => this.setState({confirmActive: false})}>
                        <span style={{color: "#143B5E", fontWeight: 700}}>Langsung Aktif</span>
                    </ModalHeader>

                    <ModalBody>
                        <p className="mb-2">
                            Anda memilih untuk <strong>melewati panduan</strong> dan langsung mengaktifkan akun.
                        </p>
                        <p className="mb-0 text-muted" style={{fontSize: "12px"}}>
                            Akun akan langsung siap digunakan dengan data contoh (dummy) yang dibuat otomatis.
                            Anda tetap bisa mengubah data kapan saja setelah masuk ke dashboard.
                        </p>
                    </ModalBody>

                    <ModalFooter className="justify-content-center">
                        <div className="row w-100 text-center">
                            <div className="col-6">
                                <button
                                    className="btn btn-outline-secondary w-100 text-center"
                                    onClick={() => this.setState({confirmActive: false})}
                                >
                                    Kembali
                                </button>
                            </div>

                            <div className="col-6">
                                <button
                                    className="btn btn-primary w-100 text-center text-white"
                                    onClick={() => {
                                        this.setState({confirmActive: false, modalSetup: false})
                                        this.submitRegister('auto')
                                    }}
                                >
                                    Ya, Langsung Aktif
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </ModalRs>

                <ModalRs
                    className="modal-content-export"
                    isOpen={this.state.confirmGuide}
                    toggle={() => this.setState({confirmGuide: false})}
                >
                    <ModalHeader toggle={() => this.setState({confirmGuide: false})}>
                        <span style={{color: "#143B5E", fontWeight: 700}}>Panduan Setup</span>
                    </ModalHeader>

                    <ModalBody>
                        <p className="mb-2">
                            Anda memilih untuk mengikuti <strong>panduan pengaturan akun</strong>.
                        </p>
                        <p className="mb-0 text-muted" style={{fontSize: "12px"}}>
                            Sistem akan membantu Anda mengatur data perusahaan, karyawan, dan pengaturan lainnya
                            secara bertahap sesuai kebutuhan bisnis Anda.
                        </p>
                    </ModalBody>

                    <ModalFooter className="justify-content-center">
                        <div className="row w-100 text-center">
                            <div className="col-6">
                                <button
                                    className="btn btn-outline-secondary w-100 text-center"
                                    onClick={() => this.setState({confirmGuide: false})}
                                >
                                    Kembali
                                </button>
                            </div>
                            <div className="col-6">
                                <button
                                    className="btn btn-primary w-100 text-center text-white"
                                    onClick={() => {
                                        this.setState({confirmGuide: false, modalSetup: false})
                                        this.submitRegister('guide')
                                    }}
                                >
                                    Ya, Mulai Panduan
                                </button>
                            </div>
                        </div>
                    </ModalFooter>
                </ModalRs>

                <ModalRs
                    className="modal-content-export"
                    isOpen={this.state.modalSetup}
                    toggle={() => this.setState({modalSetup: false})}
                >
                    <ModalHeader toggle={() => this.setState({modalSetup: false})}>
                        <span style={{color: "#143B5E", fontWeight: 700}}>Pilih Cara Pengaturan Akun</span>
                    </ModalHeader>

                    <ModalBody>
                        <p className="text-center mb-3" style={{fontSize: "13px"}}>
                            Silakan pilih salah satu cara di bawah ini untuk melanjutkan pendaftaran akun Anda.
                        </p>

                        <div className="row text-center">
                            <div className="col-6">
                                <button
                                    className="btn btn-outline-primary w-100 py-3"
                                    onClick={() => this.setState({confirmGuide: true})}
                                >
                                    <span className="d-block" style={{fontWeight: 700, fontSize: "14px"}}>
                                        Panduan
                                    </span>
                                    <small className="d-block text-muted" style={{fontSize: "10px"}}>
                                        Atur akun step-by-step
                                    </small>
                                </button>
                            </div>

                            <div className="col-6">
                                <button
                                    className="btn btn-primary w-100 py-3"
                                    onClick={() => this.setState({confirmActive: true})}
                                >
                                    <span className="d-block text-white" style={{fontWeight: 700, fontSize: "14px"}}>
                                        Langsung Aktif
                                    </span>
                                    <small className="d-block text-white" style={{fontSize: "10px"}}>
                                        Lewati panduan & siap pakai
                                    </small>
                                </button>
                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter className="justify-content-center border-0 pt-0">
                        <button
                            className="btn btn-link text-muted"
                            onClick={() => this.setState({modalSetup: false})}
                        >
                            Batal
                        </button>
                    </ModalFooter>
                </ModalRs>

                <main style={{backgroundColor: "#F9F9F9", minHeight: "90vh", marginTop: "110px"}}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col'></div>
                            <div className='col-md-4 mt-4'>
                                <div className='row'>
                                    <div className='col'>
                                        <div className='card border'>
                                            <div className='card-header border py-2 px-3' style={{
                                                backgroundColor: "#FAFDFF",
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                color: "#143B5E",
                                                lineHeight: "24px",
                                                letterSpacing: "0px"
                                            }}>Daftar Akun
                                            </div>
                                            <div className='card-body px-3 py-3' style={{backgroundColor: "#FFFFFF"}}>
                                                <div style={{fontSize: "12px"}}>
                                                    <div className="form-group">
                                                        <label htmlFor="company_name" style={{
                                                            color: "#5D6F80",
                                                            fontSize: "12px",
                                                            fontWeight: 500
                                                        }}>Nama Perusahaan</label>
                                                        <input name="company_name" style={{fontSize: "12px"}}
                                                               type="text"
                                                               className={this.state.errorsMessage.company_name ? "form-control is-invalid" : "form-control"}
                                                               id="company_name" aria-describedby="emailHelp"
                                                               placeholder="Masukkan nama perusahaan"
                                                               value={this.props.company_name}
                                                               onChange={this.handleChange}/>
                                                        <div style={{marginTop: '3px'}} className="invalid-feedback">
                                                            <strong>{this.state.errorsMessage.company_name}</strong>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="exampleInputEmail1" style={{
                                                            color: "#5D6F80",
                                                            fontSize: "12px",
                                                            fontWeight: 500
                                                        }}>Email</label>
                                                        <input name="email" style={{fontSize: "12px"}} type="email"
                                                               className={(this.state.errorsMessage.email || this.state.errorsMessage.emailregister) ? "form-control is-invalid" : "form-control"}
                                                               id="exampleInputEmail1" aria-describedby="emailHelp"
                                                               placeholder="emailanda@gmail.com"
                                                               value={this.props.email} onChange={this.handleChange}/>
                                                        <div style={{marginTop: '3px'}} className="invalid-feedback">
                                                            <strong>{this.state.errorsMessage.email || this.state.errorsMessage.emailregister}</strong>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div
                                                            className={`${this.state.errorsMessage.password ? "input-group form-password mb-5" : "input-group form-password"}`}>
                                                            <label htmlFor="exampleInputPassword1" style={{
                                                                color: "#5D6F80",
                                                                fontSize: "12px",
                                                                fontWeight: 500
                                                            }}>Password</label>
                                                            <input name="password" style={{
                                                                fontSize: "12px",
                                                                borderTopLeftRadius: "5px",
                                                                borderBottomLeftRadius: "5px"
                                                            }}
                                                                   type={this.state.showPassword === true ? "text" : "password"}
                                                                   className={this.state.errorsMessage.password ? "form-control is-invalid " : "form-control border-right-0"}
                                                                   id="exampleInputPassword1"
                                                                   placeholder="Masukkan password"
                                                                   value={this.props.password}
                                                                   onChange={this.handleChange}/>
                                                            <button
                                                                onClick={() => this.setState({showPassword: !this.state.showPassword})}
                                                                className="btn input-group-text border-left-0 pr-2 pl-2"
                                                                style={{
                                                                    fontSize: "12px",
                                                                    backgroundColor: "#FFFFFF",
                                                                    borderRadius: "0px",
                                                                    borderTopRightRadius: "5px",
                                                                    borderBottomRightRadius: "5px"
                                                                }} id="basic-addon2">
                                                                <img
                                                                    src={this.state.showPassword ? EyeSlashIcon : EyeIcons}
                                                                    alt='' style={{width: "16px", height: "16px"}}/>
                                                            </button>
                                                            <div style={{marginTop: '3px', marginBottom: "30px"}}
                                                                 className="invalid-feedback">
                                                                <strong>{this.state.errorsMessage.password}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div
                                                            className={`${this.state.errorsMessage.password ? "input-group form-password mb-5" : "input-group form-password"}`}>
                                                            <label htmlFor="exampleInputPassword1" style={{
                                                                color: "#5D6F80",
                                                                fontSize: "12px",
                                                                fontWeight: 500
                                                            }}>Konfirmasi Password</label>
                                                            <input name="confirm_password" style={{
                                                                fontSize: "12px",
                                                                borderTopLeftRadius: "5px",
                                                                borderBottomLeftRadius: "5px"
                                                            }}
                                                                   type={this.state.showConfirmPassword === true ? "text" : "password"}
                                                                   className={this.state.errorsMessage.confirm_password ? "form-control is-invalid" : "form-control border-right-0"}
                                                                   id="exampleInputPassword1"
                                                                   placeholder="Ulangi password"
                                                                   value={this.props.confirm_password}
                                                                   onChange={this.handleChange}/>
                                                            {this.props.password === this.props.confirm_password && this.props.password !== "" && this.props.confirm_password !== "" ?
                                                                <span
                                                                    className='input-group-text border-left-0 border-right-0 px-2'
                                                                    style={{
                                                                        borderRadius: "0px",
                                                                        backgroundColor: "#FFFFFF"
                                                                    }}>
                                                                <img src={CheckBlue} alt=''/>
                                                            </span>
                                                                :
                                                                ""
                                                            }
                                                            <button
                                                                onClick={() => this.setState({showConfirmPassword: !this.state.showConfirmPassword})}
                                                                className="btn input-group-text border-left-0 pr-2 pl-2"
                                                                style={{
                                                                    fontSize: "12px",
                                                                    backgroundColor: "#FFFFFF",
                                                                    borderRadius: "0px",
                                                                    borderTopRightRadius: "5px",
                                                                    borderBottomRightRadius: "5px"
                                                                }} id="basic-addon2">
                                                                <img
                                                                    src={this.state.showConfirmPassword ? EyeSlashIcon : EyeIcons}
                                                                    alt='' style={{width: "16px", height: "16px"}}/>
                                                            </button>
                                                            <div style={{marginTop: '3px'}}
                                                                 className="invalid-feedback">
                                                                <strong>{this.state.errorsMessage.confirm_password}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="input-group mb-3 form-password">
                                                            <label htmlFor="exampleInputEmail1" style={{
                                                                color: "#5D6F80",
                                                                fontSize: "12px",
                                                                fontWeight: 500
                                                            }}>Nomor Whatsapp <div
                                                                className='pull-right'>{this.props.time.s ? this.props.time.s + "s" : ""}</div>
                                                            </label>
                                                            <input name="no_whatsapp" style={{
                                                                fontSize: "12px",
                                                                borderTopLeftRadius: "5px",
                                                                borderBottomLeftRadius: "5px"
                                                            }} type="text" onChange={this.handleChange}
                                                                   className={this.props.no_whatsapp.length < 9 ? "form-control" : this.state.errorsMessage.no_whatsapp ? "form-control is-invalid" : "form-control border-right-0"}
                                                                   id="exampleInputEmail1" aria-describedby="emailHelp"
                                                                   value={this.props.no_whatsapp}
                                                                   placeholder="Masukkan nomor Whatsapp"/>
                                                            {/*{this.props.no_whatsapp.length >= 9 ?*/}
                                                            {/*    <div class="input-group-append border-left-0">*/}
                                                            {/*        <span class="input-group-text" style={{ fontSize: "12px", backgroundColor: "#FFFFFF" }} id="basic-addon2">*/}
                                                            {/*            <a style={{ fontSize: "12px", color: "#057CE4" }} onClick={this.sendOTP} disabled={this.props.disableSendOTP}>Kirim kode OTP</a>*/}
                                                            {/*        </span>*/}
                                                            {/*    </div>*/}
                                                            {/*    : ""}*/}
                                                        </div>
                                                    </div>
                                                    {/*{this.props.otpwaForm ?*/}
                                                    {/*    <div class="form-group">*/}
                                                    {/*        <label for="exampleInputPassword1" style={{ color: "#5D6F80", fontSize: "12px", fontWeight: 500 }}>Kode OTP</label>*/}
                                                    {/*        <input name="otp_code" value={this.props.otp_code} style={{ fontSize: "12px" }} type="text" class={this.state.errorsMessage.otp_code ? "form-control is-invalid" : "form-control"} id="exampleInputPassword1" placeholder="Masukkan kode otp" onChange={this.handleChange} />*/}
                                                    {/*    </div> : ""}*/}
                                                    <br/>
                                                    <button style={{
                                                        borderRadius: "8px",
                                                        paddingTop: "12px",
                                                        paddingBottom: "12px",
                                                        marginTop: "6px"
                                                    }} className={"btn btn-primary btn-block text-capitalize"}
                                                            onClick={() => this.submitRegister('guide')}>Daftar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        <div style={{textAlign: "center"}}>
                                            <p>Punya kendala saat mendaftar akun? <br/>
                                                <a href='https://wa.me/6285700102030' style={{color: "#238CE7"}}>Hubungi
                                                    kami</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col'></div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}
